<template>
  <main class="snkr-blog">
    <div class="header">
      <b-container class="max-87">
        <b-row>
          <b-col>
            <h1 class="title">SNKR BLOG</h1>
            <figure class="header-frame">
              <img :src="imgShoeSnkr" alt="shoe snkr" class="shoe-snkr" />
              <img :src="imgShoeSnkrFrame" alt="shoe snkr frame" class="shoe-snkr-frame" />
              <b-link class="b-lnk" to="/meet-the-team-behind-the-air-jordan-xxxvi" />
            </figure>
          </b-col>
          <b-col>
            <b-link class="title" to="/meet-the-team-behind-the-air-jordan-xxxvi"
              >Meet the Team Behind the Air Jordan XXXVI</b-link
            >
            <p class="desc">
              With the Air Jordan XXXVI, Jordan Brand decided to shed materials — taking the
              learnings from doing just that in the Air Jordan XXXIV and XXXV — and see how far they
              could go. "Light" was the muse.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="blog-list">
      <b-container>
        <b-row>
          <b-col>
            <h1 class="title">Newsletter</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <img
              v-for="item in items"
              :key="item.id"
              :src="item.src"
              :alt="item.alt"
              class="blog-item"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              align="center"
              class="blog-pagination"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-container>
      <div class="overlay-color" />
    </div>
    <b-container class="future-hustlers">
      <b-row>
        <b-col>
          <b-link href="https://discord.gg/snkrhud" target="_blank" class="btn-join-now"></b-link>
        </b-col>
      </b-row>
      <img
        src="@/assets/rebrand/blog/future-hustlers-elements.png"
        alt="future hustlers elements"
        class="img-future-hustlers-elements"
      />
      <img
        src="@/assets/rebrand/blog/futurehustlers.png"
        alt="future hustlers"
        class="img-future-hustlers"
      />
    </b-container>
  </main>
</template>
<script>
export default {
  name: 'SnkrBlog',
  data() {
    return {
      rows: 100,
      perPage: 10,
      currentPage: 1,
      items: [
        {
          id: 0,
          src: require('../../assets/rebrand/blog/item-1.png'),
          alt: 'item 1',
        },
        {
          id: 1,
          src: require('../../assets/rebrand/blog/item-2.png'),
          alt: 'item 2',
        },
        {
          id: 2,
          src: require('../../assets/rebrand/blog/item-3.png'),
          alt: 'item 3',
        },
        {
          id: 3,
          src: require('../../assets/rebrand/blog/item-4.png'),
          alt: 'item 4',
        },
        {
          id: 4,
          src: require('../../assets/rebrand/blog/item-5.png'),
          alt: 'item 5',
        },
      ],
      imgShoeSnkr: require('../../assets/rebrand/blog/air-jordan-xxxvi.png'),
      imgShoeSnkrFrame: require('../../assets/rebrand/blog/blog-header-frame.png'),
    };
  },
};
</script>
<style lang="scss">
@import "../../assets/styles/snkrblog.scss";
</style>
